/* =====================================================================
   Bravucón · predictive-search.js
   Buscador con sugerencias mientras se escribe ([data-ps-form] en el header):
   - Desde 2 letras pide /search/suggest?section_id=predictive-search y muestra sugerencias, categorías y productos.
   - Con el buscador vacío y enfocado muestra «Lo más buscado» (template [data-ps-popular]).
   - Flechas ↑ ↓ para moverse, Enter para abrir, Esc para cerrar. Guarda las respuestas para no repetir pedidos.
   ===================================================================== */
(function () {
  const MIN = 2;
  const DB = window.DonBarato || {};
  const route = (DB.routes && DB.routes.predictiveSearch) || '/search/suggest';

  function setup(form) {
    const input = form.querySelector('[data-ps-input]');
    const panel = form.querySelector('[data-ps-panel]');
    const popular = form.querySelector('template[data-ps-popular]');
    if (!input || !panel) return;
    const cache = new Map();
    let timer = null;
    let ctrl = null;
    let active = -1;

    const items = () => [...panel.querySelectorAll('[data-ps-item]')];

    function open(html) {
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      form.classList.add('is-ps-open');
      active = -1;
      input.removeAttribute('aria-activedescendant');
    }
    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      form.classList.remove('is-ps-open');
      active = -1;
      input.removeAttribute('aria-activedescendant');
    }
    function showPopular() {
      if (popular) open(popular.innerHTML);
      else close();
    }
    function mark(i) {
      const list = items();
      if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach((el, n) => el.classList.toggle('is-active', n === active));
      const el = list[active];
      if (el.id) input.setAttribute('aria-activedescendant', el.id);
      el.scrollIntoView({ block: 'nearest' });
    }

    async function search(q) {
      const key = q.toLowerCase();
      if (cache.has(key)) return open(cache.get(key));
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      form.classList.add('is-ps-loading');
      try {
        const url = `${route}?q=${encodeURIComponent(q)}&section_id=predictive-search` +
          '&resources[type]=query,collection,product&resources[limit]=5&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last';
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const html = (doc.querySelector('[data-ps-results]') || {}).outerHTML || '';
        cache.set(key, html);
        if (input.value.trim().toLowerCase() === key) open(html);
      } catch (err) {
        if (err.name !== 'AbortError') close();
      } finally {
        form.classList.remove('is-ps-loading');
      }
    }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length === 0) return showPopular();
      if (q.length < MIN) return close();
      timer = setTimeout(() => search(q), 160);
    });
    input.addEventListener('focus', () => {
      const q = input.value.trim();
      if (q.length === 0) showPopular();
      else if (q.length >= MIN) search(q);
    });
    input.addEventListener('keydown', (e) => {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) {
        const el = items()[active];
        if (el) { e.preventDefault(); window.location.href = el.href; }
      }
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
    form.addEventListener('submit', close);
  }

  document.querySelectorAll('[data-ps-form]').forEach(setup);
})();
